import React from 'react';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { USER_DATA_KEY } from '../../../constantes/LocalStorageEnum';
import { useFormInitialValues } from '../../../hooks/useFormInitialValues';

const AdditionalInfo: React.FC = () => {
  const userData = ApiLocalStorage.get(USER_DATA_KEY);
  const initialValues = useFormInitialValues('additionalInfo', userData);
  
  return (
    <DynamicForm
      pageName="additionalInfo"
      initialValues={initialValues}
    />
  );
};

export default AdditionalInfo;
